<template>
    <div id="the-way-wrapper" class="portfolio-page">
        <div id="the-way">
            <PortfolioHeader 
                :pageName="pageName"
                :disciplines="disciplines" 
                :services="services"
                :pageLink="pageLink"
                :linkName="linkName"
            />
            <section class="">
                <StackedPilatesSVGAnimation />
            </section>
            <ImageAndTextPortfolio 
                :imageAndTextContent="imageAndTextContent"
            />
            <section class="">
                <video 
                    src="/videos/Stacked-Pilates.mp4" 
                    loop
                    autoplay
                    muted
                    class="w-100 d-block">
                </video>
            </section>
            <ImageAndTextPortfolio 
                :imageAndTextContent="secondImageAndTextContent"
            />
            <section class="conclusion">
                <b-container class="next-project stipple-bg py-5" fluid>
                    <b-container>
                        <div class="">
                            <b-row>
                                <b-col lg="6" class="pr-md-0">
                                    <img src="/img/portfolio/stacked-pilates/stacked-pilates-front-desk.jpg" alt="Stacked Pilates - Front Desk" class="w-100 d-block">
                                </b-col>
                                <b-col lg="6" class="pl-md-0">
                                    <img src="/img/portfolio/stacked-pilates/stacked-pilates-bottle.jpg" alt="Stacked Pilates - Bottle" class="w-100 d-block">
                                </b-col>
                            </b-row>
                        </div>
                    </b-container>
                    <NextProject :nextProject="nextProject"/>
                </b-container>
            </section>
            <Transition1063 />
            <AppFooter />
        </div>
    </div>
</template>

<script>
import { gsap } from "gsap";
import { ScrollSmoother } from "gsap/ScrollSmoother";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { SplitText } from "gsap/SplitText";

export default {
    head: {
      title: "Guidelines Advertising Inc - The Underground",
      meta: [
        {
            hid: "description",
            content:
            "Guidelines Advertising is a full-service real estate marketing company with over 35 years experience in Toronto, Ontario, Canada."
        },
        { 
            hid: 'keywords', 
            name: 'keywords', 
            content: 'Toronto,Real estate décor consulting Toronto, real estate, marketing, toronto, branding, social media, web development, interior design, print, advertising, content marketing, eglinton'
        }
      ]
    },
    data() {
        return {
            scrollSmoother_theWay: null,
            textAnimation_theWay: null,
            textAnimation_theWay: null,
            disciplines: [
                {
                    name: "corporate"
                }
            ],
            services: [
                {
                    name: "brand development"
                },
                {
                    name: "logo development"
                },
                {
                    name: "website design"
                },
                {
                    name: "website implementation"
                },
                {
                    name: "stationery design"
                },
                {
                    name: "collateral design"
                }
            ],
            pageName: "Stacked Pilates",
            pageLink: "http://stackedpilatesdance.com/",
            linkName: "stackedpilatesdance.com",
            firstSliderStyles: {
                bgColor: '#d7b140',
                imgOnLeftSide: true,
                heading: "CORPORATE INITIATIVES",
                desc: "Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna",
                subheading: 'DECO CONCIERGE'
            },
            firstSliderItems: [
                {
                    img: "/img/portfolio/pier/slider/ga-slider-the-way-apologies.jpg",
                },
                {
                    img: "/img/portfolio/pier/slider/ga-slider-the-way-apologies.jpg",
                }
            ],
            secondSliderStyles: {
                bgColor: '#000',
                imgOnLeftSide: false,
                heading: "GORILLA MARKETING CAMPAIGN",
                desc: "Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna",
                subheading: 'DECO CONCIERGE'
            },
            secondSliderItems: [
                {
                    img: "/img/portfolio/deco/slider/ga-fullwidth-slider-deco-concierge.jpg",
                    heading: "GORILLA MARKETING CAMPAIGN",
                    desc: "Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna",
                    subheading: 'DECO CONCIERGE'
                },
                {
                    img: "/img/portfolio/deco/slider/ga-fullwidth-slider-deco-concierge.jpg",
                    heading: "CORPORATE INITIATIVES",
                    desc: "Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna",
                    subheading: 'DECO CONCIERGE'
                }
            ],
            imageAndTextContent: {
                imgOnLeftSide: true,
                bgColor: false,
                bgImageClass: false,
                otherSideBgClass: "stipple-bg",
                textColor: "#000",
                img: "/img/portfolio/stacked-pilates/stacked-pilates-half.jpg",
                alt: "Stacked Pilates - Absolute - Mississauga",
                heading: "Brand",
                desc: "The Stacked Pilates brand concept is greatly inspired by studio owner Alana's main mission. Stacked Pilates has become an inclusive and supportive space that positively influences well-being. 1063 successfully developed the Stacked Pilates brand into one of the most prominent wellness studios in Mississauga."
            },
            secondImageAndTextContent: {
                imgOnLeftSide: false,
                bgColor: "#3eb6e7",
                bgImageClass: false,
                otherSideBgClass: false,
                textColor: "#fff",
                img: "/img/portfolio/stacked-pilates/stacked-pilates-half-2.jpg",
                alt: "Stacked Pilates - Absolute - Mississauga",
                heading: "Brand",
                desc: "An engaging website was crucial to this brand's success. We used a holistic strategy to its design, considering every aspect of the user experience and overall brand image. As a place welcoming everyone from teenagers to clients in their 90s, those with mobility impairments, and everyone in between, the Stacked Pilates website is as accessible as its studio space. Clear visuals, intuitive navigation, and simple copy create an inviting platform that exudes positivity. "
            },
            nextProject: {
                link: "/portfolio/cetana",
                name: "Cetana"
            }
            
        }
    },
    components: {
        PortfolioHeader: () => import('@/components/PortfolioHeader'),
        FullWidthSlider: () => import('@/components/FullWidthSlider'),
        FullWidthSlider2: () => import('@/components/FullWidthSlider2'),
        ImageAndTextPortfolio: () => import('@/components/ImageAndTextPortfolio'),
        Transition1063: () => import('@/components/Transition1063'),
        NextProject: () => import('@/components/NextProject'),
        AppFooter: () => import('@/components/AppFooter'),
        StackedPilatesSVGAnimation: () => import('@/components/StackedPilatesSVGAnimation'),
    },
    mounted() {
        gsap.registerPlugin(ScrollTrigger, ScrollSmoother, SplitText);
        ScrollTrigger.refresh();
        setTimeout(() => {
            // CALL THIS FIRST SINCE ITS TECHNICALLY A SCROLLTRIGGER, SO ANY SCROLLTRIGGERS FOLLOWING THIS WOULD BE BUILT OFF OF THE SCROLLSMOOTHER
            this.initscrollSmoother_theWay();
            // 
            this.initImgElReveal_theWay();
            this.initTextReveal_theWay();
        }, 500)
    },
    methods: {
        initscrollSmoother_theWay() {
            this.scrollSmoother_theWay = ScrollSmoother.create({
                wrapper: '#the-way-wrapper',
                content: "#the-way",
                smooth: 3,
                effects: true
            });
            this.scrollSmoother_theWay.effects(".plax-img", { speed: "auto" });
        },
        initImgElReveal_theWay() {
            let fadeInUpEl = document.querySelectorAll(".fade-in-up-element");

            fadeInUpEl.forEach((container) => {
                let textAnimation_theWay = this.textAnimation_theWay;
                textAnimation_theWay = gsap.timeline({
                    scrollTrigger: {
                        trigger: container,
                        start: "center bottom",
                        stagger: 0.2
                    }
                });

                textAnimation_theWay.set(container, { autoAlpha: 1 });
                textAnimation_theWay.from(container, 1, {
                    opacity: 0,
                    y: 100,
                    ease: "power2.out"
                });
            });
        },
        initTextReveal_theWay() {
            let revealText = document.querySelectorAll(".reveal-text");
            revealText.forEach((container) => {
                let textAnimation_theWay = this.textAnimation_theWay;
                textAnimation_theWay = gsap.timeline({
                    scrollTrigger: {
                        trigger: container,
                        start: "center bottom",
                        stagger: 0.1
                    }
                });

                var splitHide = new SplitText(container, { type: "words", wordsClass: "hide-text" });
                var split = new SplitText(container, {
                    type: "words,lines",
                    wordsClass: "words",
                    linesClass: "lines"
                });
                textAnimation_theWay.set(container, { autoAlpha: 1 });
                textAnimation_theWay.from(split.words, {
                    delay: 0.5,
                    duration: 0.35,
                    yPercent: 100,
                    stagger: 0.03,
                    ease: 'power2.out'
                });
            })
        }
    },
    beforeDestroy() {
        setTimeout(() => {
            this.scrollSmoother_theWay.kill();
        }, 500)
    }
}
</script>

<style lang="scss">
@import '@/assets/styles/variables';

.portfolio-page {
    .cta-section {
        background-image: url('/img/portfolio/pier/the-way-radio.jpg');
        background-size: cover;
        background-position: center;
        width: 100%;
        height: 100%;
    }

    .pier-background {
        background: url('/img/portfolio/pier/pier-color-theme.jpg') no-repeat center center; 
        background-size: cover;
    }
}


</style>